import axios from "axios";

export interface UsersQueryParams {
    type?: string | undefined;
    filter?: string | undefined;
    parentAuthority?: string | undefined;
    matchDisabled?: boolean | undefined;
    matchSystem?: boolean | undefined;
    allowSystem?: boolean | undefined;
    maxItems?: number | undefined;
    searchBy?: string | undefined;
    uniqueKey?: string;
    selected?: string;
    selectedAuthorities?: any;
	root?: string | null;
}

export interface UsersDataServiceObject {
    [key: string]: any
}

export default class UserGroupDataModel {

    private cache: { [key: string]: any } = {};

    public searchUsers(query: UsersQueryParams = {}) {
        const params: UsersQueryParams = query;
        let urlParams = {
            type: params.type ? `&type=${params.type}` : '',
            filter: params.filter ? `&filter=${params.filter}` : '',
            parentAuthority: params.parentAuthority ? `&parentAuthority=${params.parentAuthority}` : '',
            matchDisabled: `&matchDisabled=${params.matchDisabled !== undefined ? params.matchDisabled : ''}`,
            matchSystem: `&matchSystem=${params.allowSystem ? 'true' : 'false'}`,
            maxItems: params.maxItems ? params.maxItems : 20,
            searchBy: params.searchBy ? params.searchBy : 'DISPLAYNAME',
            uniqueKey: params.uniqueKey ? params.uniqueKey : 'id',
            selected: params.selected ? params.selected : '',
            root: params.root ? `&root=${params.root}` : '',
        };
        
        Array.isArray(params.selectedAuthorities) ? params.selectedAuthorities?.forEach(function (value) {
            value?.value ? urlParams.selected+="&selected="+value.value : urlParams.selected+="&selected="+value;
        }) : params.selectedAuthorities ? urlParams.selected="&selected="+params.selectedAuthorities?.value : '';

        return axios({
            method: 'get',
            url: `${window.appContext}/proxy/alfresco/emvc/authPicker/search?maxItems=20${urlParams.root}${urlParams.filter}${urlParams.type}${urlParams.parentAuthority}${urlParams.matchDisabled}${urlParams.matchSystem}${urlParams.selected}&queryField=${urlParams.searchBy}`,
            data: null,
            headers: {
                ['Alfresco-CSRFToken']: window.Alfresco.util.CSRFPolicy.getToken(),
            },
        }).then(response => {
            response.data.filteredAuthorities.map((userObj: UsersDataServiceObject) => {
                this.cache[userObj[urlParams.uniqueKey]] = userObj;
            });
            response.data.selectedAuthorities.map((userObj: UsersDataServiceObject) => {
                this.cache[userObj[urlParams.uniqueKey]] = userObj;
            });
            return [response.data.selectedAuthorities,response.data.filteredAuthorities] as UsersDataServiceObject[];
        })
    };

    public sortByTypeByName(a: UsersDataServiceObject, b: UsersDataServiceObject) {
        var type1 = (a?.type ?? "").toLowerCase();
        var type2 = (b?.type ?? "").toLowerCase();

        var name1 = (a.lastName || a.id || "").toLowerCase();
        var name2 = (b.lastName || b.id || "").toLowerCase();

        if (type1 < type2) return -1;
        if (type1 > type2) return 1;
        if (name1 < name2) return -1;
        if (name1 > name2) return 1;
        return 0;
    };

    public async getUsersById(users: string[]) {
        const requests = users.map((user) => {
            return axios({
                method: 'get',
                url: `${window.appContext}/proxy/alfresco/emvc/authPicker/search?maxItems=1&queryField=ID&filter=${user}`,
                data: null,
                headers: {
                    ['Alfresco-CSRFToken']: window.Alfresco.util.CSRFPolicy.getToken(),
                },
            }).then(response => {
                return response?.data?.filteredAuthorities?.[0]; //Ptame se po jednom jak nam umoznuje BE pole vznika az v Promise.all()
            })
        })
        return Promise.all(requests);
    }

    public async getUserOptions(selectedUsers: any, params: UsersQueryParams) {
        if (params.uniqueKey?.toLowerCase() === 'id') {
            try {
                params.selectedAuthorities = (await this.getUsersById(
                    (typeof selectedUsers === 'string') ? [selectedUsers] : selectedUsers))?.map((item: any) => item.uuid);
            } catch (err) {
                const error: Error = err as Error;
                if (error.name === 'TypeError') {
                    console.error("Invalid Authority Key! Contact eDoCat support, please");
                    params.selectedAuthorities = (typeof selectedUsers === 'string') ? [selectedUsers] : selectedUsers;
                    return this.searchUsers({ ...params }).then((result)=>{ return [result[0].map((item:any)=>{return {...item, type:'ZZNOTFOUND', displayName:'[INVALID KEY] '+item.displayName}}),result[1]]});
                }else{
                    throw "unknown_error";
                }
            }
        } else {
            params.selectedAuthorities = (typeof selectedUsers === 'string') ? [selectedUsers] : selectedUsers;
        }
        return this.searchUsers({ ...params });
    };
}